import {
  UniDriver,
  baseUniDriverFactory,
} from '@wix/wix-ui-test-utils/unidriver';

export const tpaComponentConfigDriver = (base: UniDriver) => {
  return {
    ...baseUniDriverFactory(base),
    getChildren: base.get,
    isPaletteOverriden: async () => {
      const element = await base.getNative();
      const style = window.getComputedStyle(element);
      return style.getPropertyValue('--wix-color-50') === 'var(--wix-color-1)';
    },
  };
};
